import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { DashboardContainer } from "../base_components/dashboard_container";
import { useHistory } from "react-router-dom";

interface AdminSection {
	title: string;
	path: string;
	icon: JSX.Element;
	description: string;
}

const adminSections: AdminSection[] = [
	{
		title: "Entities",
		path: "/dashboard/admin/entities",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
			</svg>
		),
		description: "Manage database entities"
	},
	{
		title: "Stripe",
		path: "/dashboard/admin/stripe",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
			</svg>
		),
		description: "Stripe payment management"
	},
	{
		title: "Status",
		path: "/dashboard/admin/status",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>
		),
		description: "System status overview"
	},
	{
		title: "Waitlist",
		path: "/dashboard/admin/waitlist",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
			</svg>
		),
		description: "Manage waitlist entries"
	},
	{
		title: "Logs",
		path: "/dashboard/admin/logs",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
			</svg>
		),
		description: "View system logs"
	},
	{
		title: "Stats",
		path: "/dashboard/admin/stats",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
			</svg>
		),
		description: "View Sesh statistics"
	},
	{
		title: "Shards",
		path: "/dashboard/admin/shards",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2" />
			</svg>
		),
		description: "Discord shard management"
	},
	{
		title: "Blurbs",
		path: "/dashboard/admin/blurbs",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
			</svg>
		),
		description: "Manage blurbs and messages"
	},
	{
		title: "Discord Entitlements",
		path: "/dashboard/admin/entitlements",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
			</svg>
		),
		description: "Manage Discord test entitlements"
	},
	{
		title: "Bulk Delete Events",
		path: "/dashboard/admin/bulk-delete-events",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
			</svg>
		),
		description: "Delete all events by guild + author"
	},
	{
		title: "Delete User Data",
		path: "/dashboard/admin/delete-user-data",
		icon: (
			<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6" />
			</svg>
		),
		description: "Remove a user's personal data (deletion requests)"
	}
];

export function AdminPage() {
	const is_admin_query = trpc.admin.isSeshAdmin.useQuery();
	const history = useHistory();

	if (is_admin_query.isError) {
		return (
			<DashboardUtils.RenderDashboardErrorPage
				text="Must be admin to view this page"
				title="UNAUTHORIZED"
			/>
		);
	}

	if (!is_admin_query.isSuccess) {
		return <DashboardUtils.RenderFullLoadingThrobberPage />;
	}

	return (
		<DashboardContainer title={"Admin Dashboard"}>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{adminSections.map((section) => (
					<button
						key={section.path}
						onClick={() => history.push(section.path)}
						className="bg-gray-800 hover:bg-gray-700 border border-gray-600 rounded-lg p-6 text-left transition-all duration-200 hover:shadow-lg hover:scale-105"
					>
						<div className="flex items-center mb-4">
							<div className="text-blue-400 mr-3">{section.icon}</div>
							<h3 className="text-xl font-bold text-white">{section.title}</h3>
						</div>
						<p className="text-gray-400">{section.description}</p>
					</button>
				))}
			</div>
		</DashboardContainer>
	);
}
